module.exports = __webpack_public_path__ + "assets/union.d470de09.svg";